const strategySidebarGroups = [
  {
    label: 'Expected Returns (Ann.)',
    attributes: ['Exp5YRExGross', 'TranCost', 'Exp5YRExNet']
  },
  {
    label: 'Expected Risk (Ann.)',
    attributes: [
      'Exp5YRTrackingError',
      'Exp5YRInfoRatio',
      'Exp5YRVol',
      'Exp5YRSharpe'
    ]
  },
  {
    label: 'Valuations (Strategy vs. Market)',
    attributes: ['CurrentRelValAgg', 'RelValAgg50th']
  },
  {
    label: 'Historical Returns (Ann.)',
    attributes: ['HistITDExGross']
  }
]

const largeCapSidebarGroups = [
  {
    label: 'Historical Returns (Ann.)',
    attributes: ['HistITDNomGross']
  },
  {
    label: 'Historical Risk',
    attributes: ['HistITDVol', 'HistITDSharpe']
  }
]

export function getSidebarGroups({ Category }) {
  return Category === 'Benchmark'
    ? largeCapSidebarGroups
    : strategySidebarGroups
}



// WEBPACK FOOTER //
// ./src/components/strategies/aggregate/sidebar-groups.js